import React from 'react'

import '../css/footer.css'

const Footer = () => (
	<footer className="footer">
		<div id="footer-web">
			<p>POWERED BY &nbsp;
				<span className="brand-color">
					OPERA SOLUCIONES
				</span>
				. &#174;
				<a href="http://www.operasoluciones.com"
					target="_blank"
				>
					<img 
						src="img/resources/OPERA-BOTON.png" 
						alt='logo Opera'
					/>
				</a>
			</p>
		</div>
		<div id="footer-mobile">
			<div className="triangle-left">
				<span className="footer-text-mobile">
					<p>VISITA NUESTRAS</p>
					<p>REDES SOCIALES</p>
				</span>
				<div id="social-media">
					<a href=""
						target="_blank" >
						<img 
							src="img/resources/YOUTUBE-ICONO.png" 
							alt='logo Opera'
						/>
					</a>
					<a href=""
						target="_blank" >
						<img 
							src="img/resources/TWITTER-ICONO.png" 
							alt='logo Opera'
						/>
					</a>
					<a href=""
						target="_blank" >
						<img 
							src="img/resources/FACEBOOK-ICONO.png" 
							alt='logo Opera'
						/>
					</a>
				</div>
			</div>
			<div className="triangle-right">
				<p>POWERED BY <br/>
					<span className="brand-color">
						OPERA SOLUCIONES
					</span>
					 &#174;
					<br/>
					<a href="http://www.operasoluciones.com"
						target="_blank"
					>
						<img 
							src="img/resources/OPERA-BOTON.png" 
							alt='logo Opera'
						/>
					</a>
				</p>
			</div>
		</div>
	</footer>
)

export default Footer


// WEBPACK FOOTER //
// ./src/components/footer.js